module.exports = __webpack_public_path__ + "img/philanthropy.872b56d1.svg";